/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Media Plans API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
/**
 *
 * @export
 * @interface RemoveAdClientRequestDto
 */
export interface RemoveAdClientRequestDto {
    /**
     *
     * @type {string}
     * @memberof RemoveAdClientRequestDto
     */
    adClientId?: string;
}

/**
 * Check if a given object implements the RemoveAdClientRequestDto interface.
 */
export function instanceOfRemoveAdClientRequestDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RemoveAdClientRequestDtoFromJSON(json: any): RemoveAdClientRequestDto {
    return RemoveAdClientRequestDtoFromJSONTyped(json, false);
}

export function RemoveAdClientRequestDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): RemoveAdClientRequestDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        adClientId: !exists(json, 'ad_client_id') ? undefined : json['ad_client_id'],
    };
}

export function RemoveAdClientRequestDtoToJSON(value?: RemoveAdClientRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ad_client_id: value.adClientId,
    };
}
